import { Component, ReactNode } from 'react';

import { faLightRectangleHistoryWarning } from '@awesome.me/kit-8a9525ab71/icons/kit/custom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Alert, AlertDescription } from 'src/components/ui/alert';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Alert id="banner-error-retrieving-details" variant="destructive">
          <FontAwesomeIcon icon={faLightRectangleHistoryWarning} />

          <AlertDescription>
            Something went wrong. Please refresh the page or try again later.
          </AlertDescription>
        </Alert>
      );
    }

    return this.props.children;
  }
}
